import * as React from 'react';
import { FormGroup, Col, ControlLabel, Radio, FormControl, Button, Form } from 'react-bootstrap';
import { IClsOverrides } from '@nkr/models/index';
import { IClsOverrideData } from './cls-overrides-data';
import styled from 'styled-components';

const FormWrapper = styled(Form)`
    margin-bottom: 20px;
    
    .control-label {
        text-align: left;
    }

    & > .form-group {
        min-height: 30px;
    }

    & > .form-group:nth-child(odd) {
        background-color: #f9f9f9;
    }
`;

interface IState extends IClsOverrideData { };

interface IProps {
    data: IClsOverrides,
    onSave: (data: IState) => void
}

class ClsOverrides extends React.Component<IProps, IState>{
    readonly state: IState = {
        lostWageReimbursement: this.props.data != null ? this.props.data.lostWageReimbursement : -1,
        donorLifeInsurance: this.props.data != null ? this.props.data.donorLifeInsurance : -1,
        donorDisabilityInsurance: this.props.data != null ? this.props.data.donorDisabilityInsurance : -1,
        coverageforUncoveredComplications: this.props.data != null ? this.props.data.coverageforUncoveredComplications : -1,
        legalRepresentation: this.props.data != null ? this.props.data.legalRepresentation : -1,
        remoteDonation: this.props.data != null ? this.props.data.remoteDonation : -1,
        patientMicrosites: this.props.data != null ? this.props.data.patientMicrosites : -1,
        otherPrograms: this.props.data != null ? this.props.data.otherPrograms : -1,
        otherProgramsDetails: this.props.data != null ? this.props.data.otherProgramsDetails : '',
        prioritizationForDeceasedDonorTransplant: this.props.data != null ? this.props.data.prioritizationForDeceasedDonorTransplant : -1,
        travelLodgingReimbursement: this.props.data != null ? this.props.data.travelLodgingReimbursement : -1,
        lostWageReimbursementForComplication: this.props.data != null ? this.props.data.lostWageReimbursementForComplication : -1,
        travelLodgingReimbursementForComplication: this.props.data != null ? this.props.data.travelLodgingReimbursementForComplication : -1,
        prioritizationForLivingDonorTransplant: this.props.data != null ? this.props.data.prioritizationForLivingDonorTransplant : 1,
        nonSteroidalProtocol: this.props.data != null ? this.props.data.nonSteroidalProtocol : -1,
        nldacLostWage: this.props.data != null ? this.props.data.nldacLostWage : -1,
        nldacTravelLodging: this.props.data != null ? this.props.data.nldacTravelLodging : -1,
    }

    handleCancel = () => {
        window.location.href = "/center/" + this.props.data.centerId + "/profile";
    }

    handleSave = () => {
        this.props.onSave(this.state);
    }

    handleChange = (e: React.MouseEvent<Radio & HTMLInputElement>, value: any) => {
        let item = e.currentTarget.name;

        let state = { ...this.state, [item]: value };

        this.setState(state);
    }

    handleOtherProgramDetailsChange = (e: React.FormEvent<HTMLInputElement & FormControl>) => {
        this.setState({
            otherProgramsDetails: e.currentTarget.value
        });
    }

    render = () => {
        const disableSubmitButton = false;

        return (
            <div>
                <div className='container-fluid'>
                    <FormWrapper horizontal>
                        <FormGroup>
                            <Col xs={12} lg={9} componentClass={ControlLabel}>Does this transplant center provide kidney donors with Life Insurance?</Col>
                            <Col xs={12} lg={3}>
                                <Radio name="donorLifeInsurance" inline checked={this.state.donorLifeInsurance == 1} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, 1)}>
                                    Yes
                                </Radio>{' '}
                                <Radio name="donorLifeInsurance" inline checked={this.state.donorLifeInsurance == 0} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, 0)}>
                                    No
                                </Radio>{' '}
                                <Radio name="donorLifeInsurance" inline checked={this.state.donorLifeInsurance == -1} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, -1)}>
                                    No Override
                                </Radio>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col xs={12} lg={9} componentClass={ControlLabel}>Does this transplant center provide kidney donors with Short Term Disability Insurance?</Col>
                            <Col xs={12} lg={3}>
                                <Radio name="donorDisabilityInsurance" inline checked={this.state.donorDisabilityInsurance == 1} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, 1)}>
                                    Yes
                                </Radio>{' '}
                                <Radio name="donorDisabilityInsurance" inline checked={this.state.donorDisabilityInsurance == 0} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, 0)}>
                                    No
                                </Radio>{' '}
                                <Radio name="donorDisabilityInsurance" inline checked={this.state.donorDisabilityInsurance == -1} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, -1)}>
                                    No Override
                                </Radio>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col xs={12} lg={9} componentClass={ControlLabel}>Does this transplant center provide coverage for complications that are not covered by the patients insurance?</Col>
                            <Col xs={12} lg={3}>
                                <Radio name="coverageforUncoveredComplications" inline checked={this.state.coverageforUncoveredComplications == 1} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, 1)}>
                                    Yes
                                </Radio>{' '}
                                <Radio name="donorDisacoverageforUncoveredComplicationsbilityInsurance" inline checked={this.state.coverageforUncoveredComplications == 0} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, 0)}>
                                    No
                                </Radio>{' '}
                                <Radio name="coverageforUncoveredComplications" inline checked={this.state.coverageforUncoveredComplications == -1} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, -1)}>
                                    No Override
                                </Radio>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col xs={12} lg={9} componentClass={ControlLabel}>Does this transplant center provide legal support for donors?</Col>
                            <Col xs={12} lg={3}>
                                <Radio name="legalRepresentation" inline checked={this.state.legalRepresentation == 1} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, 1)}>
                                    Yes
                                </Radio>{' '}
                                <Radio name="legalRepresentation" inline checked={this.state.legalRepresentation == 0} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, 0)}>
                                    No
                                </Radio>{' '}
                                <Radio name="legalRepresentation" inline checked={this.state.legalRepresentation == -1} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, -1)}>
                                    No Override
                                </Radio>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col xs={12} lg={9} componentClass={ControlLabel}>Does this transplant center offer access to the Remote Donation Network so that a donor can donate in a location that is convenient for their recovery?</Col>
                            <Col xs={12} lg={3}>
                                <Radio name="remoteDonation" inline checked={this.state.remoteDonation == 1} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, 1)}>
                                    Yes
                                </Radio>{' '}
                                <Radio name="remoteDonation" inline checked={this.state.remoteDonation == 0} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, 0)}>
                                    No
                                </Radio>{' '}
                                <Radio name="remoteDonation" inline checked={this.state.remoteDonation == -1} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, -1)}>
                                    No Override
                                </Radio>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col xs={12} lg={9} componentClass={ControlLabel}>Does this transplant center offer a microsite system to allow patients to create a website to explain why they need a kidney donor, and to enroll the donors to start a donation journey?</Col>
                            <Col xs={12} lg={3}>
                                <Radio name="patientMicrosites" inline checked={this.state.patientMicrosites == 1} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, 1)}>
                                    Yes
                                </Radio>{' '}
                                <Radio name="patientMicrosites" inline checked={this.state.patientMicrosites == 0} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, 0)}>
                                    No
                                </Radio>{' '}
                                <Radio name="patientMicrosites" inline checked={this.state.patientMicrosites == -1} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, -1)}>
                                    No Override
                                </Radio>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col xs={12} lg={9} componentClass={ControlLabel}>Does this transplant center participate in other programs?</Col>
                            <Col xs={12} lg={3}>
                                <Radio name="otherPrograms" inline checked={this.state.otherPrograms == 1} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, 1)}>
                                    Yes
                                </Radio>{' '}
                                <Radio name="otherPrograms" inline checked={this.state.otherPrograms == 0} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, 0)}>
                                    No
                                </Radio>{' '}
                                <Radio name="otherPrograms" inline checked={this.state.otherPrograms == -1} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, -1)}>
                                    No Override
                                </Radio>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col xs={12} lg={9} componentClass={ControlLabel}>What other programs does this transplant center participate in (pain reduction, etc)?</Col>
                            <Col xs={12} lg={3}>
                                <FormControl
                                    componentClass='textarea'
                                    value={this.state.otherProgramsDetails}
                                    onChange={this.handleOtherProgramDetailsChange}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col xs={12} lg={9} componentClass={ControlLabel}>Does this transplant center educate donors that they are eligible for a priority spot on the deceased donor transplant list as a living organ donor?</Col>
                            <Col xs={12} lg={3}>
                                <Radio name="prioritizationForDeceasedDonorTransplant" inline checked={this.state.prioritizationForDeceasedDonorTransplant == 1} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, 1)}>
                                    Yes
                                </Radio>{' '}
                                <Radio name="prioritizationForDeceasedDonorTransplant" inline checked={this.state.prioritizationForDeceasedDonorTransplant == 0} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, 0)}>
                                    No
                                </Radio>{' '}
                                <Radio name="prioritizationForDeceasedDonorTransplant" inline checked={this.state.prioritizationForDeceasedDonorTransplant == -1} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, -1)}>
                                    No Override
                                </Radio>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col xs={12} lg={9} componentClass={ControlLabel}>Does this transplant center offer prioritization for a living donor kidney should they need one in the future?</Col>
                            <Col xs={12} lg={3}>
                                <Radio name="prioritizationForLivingDonorTransplant" inline checked={this.state.prioritizationForLivingDonorTransplant == 1} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, 1)}>
                                    Yes
                                </Radio>{' '}
                                <Radio name="prioritizationForLivingDonorTransplant" inline checked={this.state.prioritizationForLivingDonorTransplant == 0} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, 0)}>
                                    No
                                </Radio>{' '}
                                <Radio name="prioritizationForLivingDonorTransplant" inline checked={this.state.prioritizationForLivingDonorTransplant == -1} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, -1)}>
                                    No Override
                                </Radio>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col xs={12} lg={9} componentClass={ControlLabel}>Does this transplant center offer reimbursement of travel and lodging expenses related to kidney donation?</Col>
                            <Col xs={12} lg={3}>
                                <Radio name="travelLodgingReimbursement" inline checked={this.state.travelLodgingReimbursement == 1} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, 1)}>
                                    Yes
                                </Radio>{' '}
                                <Radio name="travelLodgingReimbursement" inline checked={this.state.travelLodgingReimbursement == 0} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, 0)}>
                                    No
                                </Radio>{' '}
                                <Radio name="travelLodgingReimbursement" inline checked={this.state.travelLodgingReimbursement == -1} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, -1)}>
                                    No Override
                                </Radio>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col xs={12} lg={9} componentClass={ControlLabel}>Does this transplant center offer reimbursement of travel and lodging expenses related to kidney donation through NLDAC?</Col>
                            <Col xs={12} lg={3}>
                                <Radio name="nldacTravelLodging" inline checked={this.state.nldacTravelLodging == 1} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, 1)}>
                                    Yes
                                </Radio>{' '}
                                <Radio name="nldacTravelLodging" inline checked={this.state.nldacTravelLodging == 0} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, 0)}>
                                    No
                                </Radio>{' '}
                                <Radio name="nldacTravelLodging" inline checked={this.state.nldacTravelLodging == -1} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, -1)}>
                                    No Override
                                </Radio>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col xs={12} lg={9} componentClass={ControlLabel}>Does this transplant center offer reimbursement of travel and lodging expenses in the event of a kidney donation complication?</Col>
                            <Col xs={12} lg={3}>
                                <Radio name="travelLodgingReimbursementForComplication" inline checked={this.state.travelLodgingReimbursementForComplication == 1} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, 1)}>
                                    Yes
                                </Radio>{' '}
                                <Radio name="travelLodgingReimbursementForComplication" inline checked={this.state.travelLodgingReimbursementForComplication == 0} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, 0)}>
                                    No
                                </Radio>{' '}
                                <Radio name="travelLodgingReimbursementForComplication" inline checked={this.state.travelLodgingReimbursementForComplication == -1} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, -1)}>
                                    No Override
                                </Radio>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col xs={12} lg={9} componentClass={ControlLabel}>Does this transplant center provide Lost Wage Reimbursement for kidney donation surgery?</Col>
                            <Col xs={12} lg={3}>
                                <Radio name="lostWageReimbursement" inline checked={this.state.lostWageReimbursement == 1} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, 1)}>
                                    Yes
                                </Radio>{' '}
                                <Radio name="lostWageReimbursement" inline checked={this.state.lostWageReimbursement == 0} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, 0)}>
                                    No
                                </Radio>{' '}
                                <Radio name="lostWageReimbursement" inline checked={this.state.lostWageReimbursement == -1} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, -1)}>
                                    No Override
                                </Radio>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col xs={12} lg={9} componentClass={ControlLabel}>Does this transplant center offer reimbursement of lost wages related to kidney donation through NLDAC?</Col>
                            <Col xs={12} lg={3}>
                                <Radio name="nldacLostWage" inline checked={this.state.nldacLostWage == 1} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, 1)}>
                                    Yes
                                </Radio>{' '}
                                <Radio name="nldacLostWage" inline checked={this.state.nldacLostWage == 0} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, 0)}>
                                    No
                                </Radio>{' '}
                                <Radio name="nldacLostWage" inline checked={this.state.nldacLostWage == -1} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, -1)}>
                                    No Override
                                </Radio>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col xs={12} lg={9} componentClass={ControlLabel}>Does this transplant center offer reimbursement of lost wageg in the event of a kidney donation complication?</Col>
                            <Col xs={12} lg={3}>
                                <Radio name="lostWageReimbursementForComplication" inline checked={this.state.lostWageReimbursementForComplication == 1} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, 1)}>
                                    Yes
                                </Radio>{' '}
                                <Radio name="lostWageReimbursementForComplication" inline checked={this.state.lostWageReimbursementForComplication == 0} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, 0)}>
                                    No
                                </Radio>{' '}
                                <Radio name="lostWageReimbursementForComplication" inline checked={this.state.lostWageReimbursementForComplication == -1} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, -1)}>
                                    No Override
                                </Radio>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col xs={12} lg={9} componentClass={ControlLabel}>Does this transplant center offer a non steroidal post transplant treatment option for kidney recipients?</Col>
                            <Col xs={12} lg={3}>
                                <Radio name="nonSteroidalProtocol" inline checked={this.state.nonSteroidalProtocol == 1} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, 1)}>
                                    Yes
                                </Radio>{' '}
                                <Radio name="nonSteroidalProtocol" inline checked={this.state.nonSteroidalProtocol == 0} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, 0)}>
                                    No
                                </Radio>{' '}
                                <Radio name="nonSteroidalProtocol" inline checked={this.state.nonSteroidalProtocol == -1} onClick={(e: React.MouseEvent<Radio & HTMLInputElement>) => this.handleChange(e, -1)}>
                                    No Override
                                </Radio>
                            </Col>
                        </FormGroup>
                    </FormWrapper>

                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <Button bsStyle='primary' bsSize='lg' onClick={this.handleSave} disabled={disableSubmitButton}>SUBMIT CLS OVERRIDES</Button>
                    </div>
                </div>
            </div>
        )
    }
}

export default ClsOverrides;